import React from "react";

import { formatCurrency, formatKwh, formatTariff, hasValue } from "../shared/formatters";
import { ModalDetailsDivider, ModalDetailsRow } from "../shared/ModalDetailsTable";
import { PriceWithoutGeedeeDetails } from "../shared/types";

export const PriceWithoutGeedeeContent = ({
  details,
}: {
  details?: PriceWithoutGeedeeDetails | null;
}) => {
  const consumption = details?.consumption_details;
  const expenses = details?.other_expenses;
  const accountTotal = details?.account_total;
  const expenseItems = expenses?.items?.filter((item) => hasValue(item?.amount_brl)) || [];

  const hasConsumption =
    hasValue(consumption?.energy_consumed_kwh) ||
    hasValue(consumption?.energy_tariff_brl_per_kwh) ||
    hasValue(consumption?.total_consumption_brl);
  const hasExpenses = expenseItems.length > 0 || hasValue(expenses?.total_other_expenses_brl);
  const hasAccountTotal = hasValue(accountTotal?.total_amount_brl);

  if (!hasConsumption && !hasExpenses && !hasAccountTotal) return null;

  return (
    <div className="mx-auto w-full max-w-2xl text-sm leading-normal">
      {hasConsumption && (
        <>
          <ModalDetailsRow
            label="Energia Consumida"
            value={formatKwh(consumption?.energy_consumed_kwh)}
            unit="kWh"
          />
          <ModalDetailsRow
            label="Tarifa de energia cativa light"
            currency="R$"
            value={formatTariff(consumption?.energy_tariff_brl_per_kwh)}
            unit="R$/kWh"
          />
          <ModalDetailsDivider />
          <ModalDetailsRow
            label="Total Consumo"
            currency="R$"
            value={formatCurrency(consumption?.total_consumption_brl)}
            strong
          />
          <ModalDetailsDivider />
        </>
      )}

      {hasExpenses && (
        <div className="mt-5">
          {expenseItems.map((item, index) => (
            <ModalDetailsRow
              key={`${item.description || item.source_description}-${index}`}
              label={item.description || item.source_description || "Despesa"}
              currency="R$"
              value={formatCurrency(item.amount_brl)}
            />
          ))}
          <ModalDetailsDivider />
          <ModalDetailsRow
            label="Total Outras Despesas"
            currency="R$"
            value={formatCurrency(expenses?.total_other_expenses_brl)}
            strong
          />
          <ModalDetailsDivider />
        </div>
      )}

      {hasAccountTotal && (
        <div className="mt-6">
          <ModalDetailsDivider />
          <ModalDetailsRow
            label="Total da Conta"
            currency="R$"
            value={formatCurrency(accountTotal?.total_amount_brl)}
            strong
          />
          <ModalDetailsDivider />
        </div>
      )}
    </div>
  );
};
